import { render, staticRenderFns } from "./formBrandList.vue?vue&type=template&id=43e90c9f&scoped=true&"
import script from "./formBrandList.vue?vue&type=script&lang=js&"
export * from "./formBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e90c9f",
  null
  
)

export default component.exports